jQuery(document).ready(function ($) {

    let highQualityImg = new Image();

    if (window.innerWidth > 600) {
        highQualityImg.src = "/wp-content/themes/nix_united/assets/img/footer/subscription-form-bg.png";
    } else {
        highQualityImg.src = "/wp-content/themes/nix_united/assets/img/footer/subscription-form-bg-mob.png";
    }

    highQualityImg.onload = function() {
        document.querySelector('.subscribe-form').classList.add('hq-loaded');
    }

    $(".footer-recognitions-list-slider").slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnFocus: false,
        pauseOnHover: false,

        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
            event.stopPropagation();
            if (!event.target.classList.value.includes("recognitions-list-slider")) {
                return false;
            }
        });
    $(".js-open-popup").on("click", function () {
        $(".footer-form-subscribe").addClass("is-active");
        $(".footer-form-subscribe .gfield_validation_message").text("").hide();
        $(".footer-form-subscribe input[aria-invalid='true']").attr("aria-invalid", "false");
    });

    $(".close-popup-button").on("click", function () {
        $(".footer-form-subscribe").removeClass("is-active");
    });

    $(".footer-form-subscribe").on("click", function (e) {
        if (!$(e.target).closest(".subscribe-form").length) {
            $(".footer-form-subscribe").removeClass("is-active");
        }
    });

    jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
        if (formId === 29) {
            checkSubscribeCookie();
        }
    });

    checkSubscribeCookie();

    function getCookie(name) {
        return document.cookie.split("; ").find(row => row.startsWith(name + "="))?.split("=")[1];
    }
    function checkSubscribeCookie() {
        if (getCookie("subscribe") === "true") {
            document.querySelector(".footer-subscribe-form")?.classList.add("subscribed");
            document.querySelector(".subscribe-form")?.classList.add("confirmation-img");
        }
    }
});



